import React from 'react'
import AccountForm from '../../types/account-form.types'
import { Lang } from '../../types/common-types'
import { State, Dispatch } from '../../state-actions-reducers'
import cn from 'classnames'
import styles from './AcceptConditions.module.scss'
import MainCheckMark from '../../images/mainCheckMark.svg'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'

interface Props {
  lang: Lang
  parentUrl: string
  accountForm: AccountForm
  state: State
  dispatch: Dispatch
  activeForm: 'Physical' | 'Company' | 'Individual'
  changeActiveForm: (e: 'Physical' | 'Company' | 'Individual') => void
}

export default function AcceptConditions({
  lang,
  parentUrl,
  accountForm,
  state,
  dispatch,
  activeForm,
  changeActiveForm
}: Props) {

  const formType: ("Physical" | "Company" | "Individual")[] = ["Physical", "Company", "Individual"]
  return (
    <div className="row">
      <div className="col-12 col-xs-12">
        <div className={styles.tabs}>
          {formType.map((e) => {
            return <div onClick={() => changeActiveForm(e)} className={cn(styles.tabs_item, activeForm === e && styles.active)}>
              {e === 'Physical' ? accountForm.profileType_PhysicalButton[lang] :
                e === 'Company' ? accountForm.profileType_FiscalButton[lang] :
                  e === "Individual" ? accountForm.profileType_FiscalIPButton[lang] : null
              }
            </div>
          })}
        </div>
      </div>
      <InfoMessage type={'default'} text={<div className={styles.agreementContainer}>
        <span>{accountForm.agreementShowBtnTipText[lang]} </span>
        <a target='_blank' href={`${parentUrl}info/client-form/documents`}>{accountForm.agreementShowBtnTip[lang]}</a>
      </div>} />
      <div className={styles.cheklist}>
        <div className={styles.cheklist_item}>
          <img src={MainCheckMark} alt="checkmark" />
          <span>{accountForm.agreementButtonConfurmLabel1[lang]} <a target='_blank' href={`${parentUrl}info/client-form/documents`}>{accountForm.agreementButtonConfurmLabel2[lang]}</a></span>
        </div>
        <div className={styles.cheklist_item}>
          <img src={MainCheckMark} alt="checkmark" />
          <span>{accountForm.agreementButtonConfurmLabel3[lang]} 7813216143</span>
        </div>
      </div>
    </div>
  )
}